import { Controller } from "@hotwired/stimulus"
import { deepMerge } from '@javascript/javascripts/utils'
import './carousel_component.css'
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export default class extends Controller {

  static get targets() {
    return []
  }

  initialize() {
    this.options = JSON.parse(this.data.get('options'))
    this._boot()
  }

  _boot(){
    if(!this.element.dataset.behaviorLoaded){
      this.element.classList.add('carousel--loading');
      const defaults = {
        touch: true,
        nav: false,
        nonce: 'oVyNsBBOgnKX4o3kiJDiAQ=='
      }
      this.carousel = new Splide(this.element, deepMerge(defaults, this.options))
      this.carousel.mount()
      this.element.classList.remove('carousel--loading')
      this.element.dataset.behaviorLoaded = true
    }
  }

}
